// Service pour récupérer les stats de cycle
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface CourseStats {
  cycle_score_mean: { [cycleId: string]: number | null };
  global_score?: number | null;
  td_cycle_mean?: { [cycleId: string]: { [td: string]: number | null } };
  td_global_mean?: { [td: string]: number | null };
}

class StatsService {
  async getCourseStats(accessToken: string): Promise<CourseStats> {
    const response = await fetch(`${API_BASE_URL}/cycle_results/stats`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
}

export const statsService = new StatsService();
